import { render } from "./searchHumanityVideoList.vue?vue&type=template&id=caabc1e4&scoped=true"
import script from "./searchHumanityVideoList.vue?vue&type=script&lang=js"
export * from "./searchHumanityVideoList.vue?vue&type=script&lang=js"

import "./searchHumanityVideoList.vue?vue&type=style&index=0&id=caabc1e4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caabc1e4"]])

export default __exports__